import axios from '../../axios'

export default {
  getIncidents: function () {
    return axios.get('incidents')
  }
}



// WEBPACK FOOTER //
// ./src/services/api/IncidentsApi.js